import React from "react";
import { InputBase, Paper, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";

const SearchBox = ({ value, onChange, onSearch }) => {
  return (
    <Paper
      component="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (onSearch) onSearch();
      }}
      sx={{
        display: "flex",
        alignItems: "center",
        width: "90%",
        border: "1px solid #ccc",
        borderRadius: "10px",
        boxShadow: "none",
        px: 2,
        py: 0.5,
      }}
    >
      <IconButton type="submit" sx={{ p: 0.5 }} aria-label="search">
        <SearchIcon sx={{ color: "#aaa" }} />
      </IconButton>
      <InputBase
        sx={{ ml: 0.5, flex: 1, fontWeight: 600 }}
        placeholder="Search"
        value={value}
        onChange={onChange}
        inputProps={{ "aria-label": "search" }}
      />
    </Paper>
  );
};

export default SearchBox;
